import { isNotDefined } from '@sgme/fp';
import type { FieldMetadata } from 'models/forms/fields';
import { connect } from 'react-redux';
import type { QuoteFormError } from 'state/addonForm/addonForm.selector';
import { FieldMetadataById } from 'state/common-form/metaData/fields/fields.model';
import { getFieldsMetadata } from 'state/forms/metadata/selectors';
import { getSidePanelValidationErrors } from 'state/selectors';
import type { AppState } from 'state/state.model';

export interface OwnProps {
  tabId: string;
  workspaceType: 'static' | 'dynamic' | 'postTrade';
}

export interface StateProps {
  validationErrors: readonly QuoteFormError[];

  hiddenFields: readonly string[];
}

export type ValidationErrorsState = StateProps & OwnProps;

function isHidden(meta: FieldMetadata | undefined | null): boolean {
  if (isNotDefined(meta)) {
    return true;
  }
  if (meta.isHidden === true) {
    return true;
  }
  if (meta.type === 'Technical' || meta.type === 'Blank') {
    return true;
  }
  return false;
}
const EMPTY_FIELDS_METADATA: FieldMetadataById = {};
function getHiddenFieldsForForm(state: AppState, workspace: 'static' | 'dynamic' | 'postTrade', tabId: string) {
  const fieldsMetadata =
    workspace === 'static' ? getFieldsMetadata(state, 'static', tabId) : getFieldsMetadata(state, 'dynamic', tabId);
  return Object.entries(fieldsMetadata ?? EMPTY_FIELDS_METADATA)
    .filter(([_, metadata]) => isHidden(metadata))
    .map(([field, _]) => field);
}

export const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  return {
    validationErrors: getSidePanelValidationErrors(state, workspaceType, tabId),
    hiddenFields: getHiddenFieldsForForm(state, workspaceType, tabId),
  };
};

export const connectValidationErrors = connect(mapStateToProps);
